<template>
  <div>
    <!--顶部按钮-->
    <div class="app-container">
      <div style="height: 30px">
        <vxe-button type="primary" v-auth="`ADD`" @click="handleAdd">新增</vxe-button>
        <vxe-button v-if="false" class="el-icon-download" type="primary" @click="deriveFun">导出</vxe-button>
        <div style="float: right; color: #848484; display: flex; line-height: 28px">
          <el-input v-model="queryCondition.accountName" placeholder="账期名称" clearable style="width: 60%; margin-right: 1rem" @keyup.enter.native="queryByPage(1)" />
          <vxe-button status="primary"  @click="queryByPage(1)">搜索</vxe-button>
          <vxe-button type="info" class="filter-search-item" @click="resetForm">重置</vxe-button>
        </div>
      </div>
      <!--table列表-->
      <vxe-table
        ref="xTable"
        v-loading="listLoading"
        :align="allAlign"
        :max-height="$store.state.app.height - 130 < 500 ? 500 : $store.state.app.height - 130"
        border
        show-header-overflow
        show-overflow
        class="mytable-scrollbar"
        :column-config="{ resizable: true }"
        stripe
        round
        style="margin-top: 10px"
        :sort-config="{remote: true}"
        :scroll-y="{ enabled: false }"
        :row-config="{ isHover: true }"
        :data="tableData"
        @sort-change="listSortMethod"
      >
        <vxe-column type="checkbox" width="60" align="center" />
        <vxe-column type="seq" title="序号" width="60" align="center" />
        <vxe-column v-if="false" field="id" title="id" width="80" />
        <vxe-column field="accountName" title="账期名称" width="150" />
        <vxe-column field="budgetTypeName" title="预算类型" width="150" />
        <vxe-column field="business" title="商务政策来源" width="150" />
        <vxe-column field="beginTime" title="有效期-开始时间" width="150" />
        <vxe-column field="endTime" title="有效期-结束时间" width="150" />
        <vxe-column field="status" title="状态" width="150">
          <template #default="{ row }">
            {{ row.status | toCnStatus }}
          </template>
        </vxe-column>
        <vxe-column field="createUser" title="创建人" width="150" />
        <vxe-column field="createTime" title="创建时间" width="150" sortable />
        <vxe-column title="操作" width="200" fixed="right" align="center">
          <template #default="{ row }">
            <div class="operate" style="height:30px">
              <a-button type="link" v-auth="`VIEW`" @click="viewDetail(row)">查看</a-button>
              <a-button  type="link" v-auth="`UPDATE`" @click="editDetail(row)">编辑</a-button>
              <a-button type="link" v-auth="`DELETE`" @click="deleteFun(row)">删除</a-button>
            </div>
          </template>
        </vxe-column>
      </vxe-table>
      <vxe-pager
        :current-page="pagination.current"
        :page-size="pagination.size"
        :total="pagination.total"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
        @page-change="changePage"
      />
    </div>
    <!--导出对话框 -->
    <el-dialog title="选择导出项" :visible.sync="dialogVisible" width="400px">
      <el-radio-group v-model="ExportItem">
        <el-radio :label="0">导出全部</el-radio>
        <el-radio :label="1">导出当前页</el-radio>
        <el-radio :label="2" :disabled="disabled">导出已选择项</el-radio>
      </el-radio-group>
      <span slot="footer" class="dialog-footer">
        <vxe-button @click="dialogVisible = false">取 消</vxe-button>
        <vxe-button type="primary" :loading="outExcelButtonLocading" @click="exportXlsxFun">确 定</vxe-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import permission from '@/directive/permission/index.js' // 权限判断指令
import { exportMaterial } from '@/api/material'
import { outExcel } from '@/utils/Excel/outExcel'
import { findList, deleted } from '@/api/amount'

const defaultPagination = {
  total: 0,
  size: 20,
  current: 1
}

export default {
  // 广宣物料管理/广宣物料维护,
  name: 'DealerAmountMList',
  // directives: { permission },
  data() {
    return {
      pagination: Object.assign({}, defaultPagination),
      listLoading: false,
      tableData: [],
      sort: 'create_time desc',
      allAlign: 'center',
      queryCondition: {},
      // 导出对话框
      dialogVisible: false,
      disabled: true, // 已选择按钮是否禁用
      outExcelButtonLocading: false,
      ExportItem: 0
    }
  },

  created() {
    // 获取表格数据
    this.queryByPage()
  },
  activated() {
    // 获取表格数据
    this.queryByPage()
  },
  methods: {
    deriveFun() {
      this.dialogVisible = true
      // 判断是否选中
      this.disabled = this.$refs.xTable.selection.length < 1
    },
    // 导出表格
    async exportXlsxFun() {
      // 需要导出的数据
      let data = []
      const typeMap = new Map([
        ['1', '销售物料'],
        ['2', '礼品物料'],
        ['3', '宣传物料'],
        ['4', '其它']
      ])
      const warehouse = new Map([
        ['1', '外部仓库'],
        ['2', '内部仓库']
      ])
      this.outExcelButtonLocading = true
      if (this.ExportItem == 0) {
        if (this.pagination.total > 10000) {
          this.$message.warning('导入' + this.pagination.total + '条，过程可能持续数分钟。')
        }
        const data = { page: 1, limit: this.pagination.total, ...this.queryCondition }
        exportMaterial(data).then(val => {
          this.$exportExcelData(val, `广宣物料表 ${new Date().Format('yyyy年MM月DD日 HH点mm分')}.xlsx`)
          this.dialogVisible = false
          this.outExcelButtonLocading = false
        })
        return
      } else if (this.ExportItem == 1) {
        data = this.tableData
      } else if (this.ExportItem == 2) {
        data = this.$refs.xTable.selection
      }
      const table = []
      for (var i = 0; i < data.length; i++) {
        var params = {
          物料号: data[i].materialCode,
          物料名称: data[i].materialName,
          // 物料类型: data[i].materialType,
          物料类型: typeMap.get(data[i].materialType),
          物料规格: data[i].specification,
          库存: data[i].storage,
          申领价: data[i].price,
          制作价: data[i].prodPrice,
          单位: data[i].unit,
          // 所属仓库: data[i].warehouse,
          所属仓库: warehouse.get(data[i].warehouse),
          供应商: data[i].supplier,
          备注: data[i].remark,
          新增人: data[i].createUser,
          新增时间: data[i].createrDate,
          更新时间: data[i].updateTime
        }
        table[i] = params
      }
      const wch = [15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 15, 25, 25]
      outExcel('广宣物料表', table, wch)
      // 关闭弹窗
      this.dialogVisible = false
      this.outExcelButtonLocading = false
    },
    listSortMethod({ column, sortList }) {
      console.log("🚀 ~ listSortMethod ~ column:", column)
      let sort = ''
      for (let i = 0; i < sortList.length; i++) {
        if (i !== 0) {
          sort = sort + ','
        }
        sort = sort + sortList[i].field + ' ' + sortList[i].order
      }
      this.sort = sort
      this.queryByPage()
    },
    // 上传前对文件的大小的判断
    uploadBefore(file) {
      const extension = file.name.substring(file.name.lastIndexOf('.') + 1)
      const size = file.size / 1024 / 1024
      if (extension !== 'xlsx' && extension !== 'xls') {
        this.$message('只能上传后缀是.xlsx或者.xls的文件')
        return false
      }

      if (size > 10) {
        this.$message('文件大小不得超过10M')
        return false
      }
    },
    handleAdd() {
      this.$router.push({
        path: `dealerAmountMDetail/null`
      })
    },
    viewDetail(row) {
      this.$router.push({
        path: `dealerAmountMDetail/${row.id}/view`
      })
    },
    editDetail(row) {
      this.$router.push({
        path: `dealerAmountMDetail/${row.id}/edit`
      })
    },
    deleteFun(row) {
      this.$confirm({
        title: '确定删除该账期？',
        content: '',
        onOk:() => {
          deleted(row.id).then(res => {
            if (res.code === 1) {
              this.$message.success('删除成功')
              this.queryByPage()
            } else {
              this.$message.error(res.message)
            }
          })
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    // 分页
    changePage({ currentPage, pageSize }) {
      this.pagination.current = currentPage
      if (pageSize != this.pagination.size) this.pagination.current = 1
      this.pagination.size = pageSize
      this.queryByPage()
    },
    // 重置筛选
    resetForm() {
      this.queryCondition = {}
      this.queryByPage(1)
    },
    // 搜索表格数据
    queryByPage(e) {
      if (e) this.pagination.current = e
      // 筛选条件
      const queryData = {
        page: this.pagination.current,
        limit: this.pagination.size,
        sort: this.sort,
        ...this.queryCondition
      }
      this.listLoading = true // 开启加载动画
      findList(queryData).then(res => {
        if (res.code === 1 && res.data) {
          this.tableData = res.data.list
          this.pagination.total = res.data.total
          this.listLoading = false
        }
      })
    }
  }
}
</script>
<style lang="less">
.el-input__inner {
  height: 30px;
}
.operate {
  display: flex;
  justify-content: space-around;
}
.el-link {
  font-size: 12px;
}
.load-buttom {
  text-decoration: none;
  float: right;
  height: 30px;
  padding: 0 10px;
  text-align: right;
  line-height: 30px;
  color: #00a7e5;
  display: inline-block;
  font-size: 12px;
}
.load-buttom:hover {
  color: #00b7bf;
}
.err-box {
  margin-top: 10px;
}
.pic-box {
  display: inline-block;
  padding: 5px;
}
</style>
